import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { PATHS } from '../../common/constants';
import {
  setContactFormData,
  clearContactFormData,
} from '../../store/actions/contactForm';
import AddressInformation from '../../components/AddressCard';
import Avatar from '../../components/Avatar';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import ContactCard from '../../components/ContactCard';
import ContactForm from '../../components/ContactForm';
import Details from '../../components/Details';
import Icon from '../../components/Icon';
import Metrics from '../../components/Metrics';
import Overlay from '../../components/Overlay';
import { deleteContactById } from '../../store/actions/contacts';
import {
  onClearMoreDetails,
  onFetchContactMoreDetails,
} from '../../store/actions/suites';
import { selectLoader } from '../../store/selectors/loader';
import Loader from '../../components/Loader';
import ContactMoreDetails from './ContactMoreDetails';
import { serviceRequestTableLocalTime } from '../../helpers/validationHelper';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import './ContactDetails.scss';

class ContactDetails extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
  };

  componentDidMount() {
    this.props.onClearMoreDetails();
  }

  onFetchMoreDetails = () => {
    this.props.onFetchContactMoreDetails(this.props.contact.id);
  };

  render() {
    const {
      contact,
      onSetContactFormData,
      onClearContactFormData,
      onSubmitContactForm,
      onDeleteContact,
      sendResetPasswordLinkToUser,
      sendActivationLinkToUser,
      navFrom,
      counts,
      isFromDashBoard,
      moreDetails,
      user,
    } = this.props;
    const { showOverlay } = this.state;
    let { isOpen } = this.state;
    return (
      <div className="contact-details">
        <div className="contact-details__top">
          <div className="contact-details__breadcrumb">
            {isFromDashBoard === true ? (
              <Breadcrumb
                label="MY HOME"
                to={{
                  pathname: PATHS.SUITES_VIEW.replace(
                    ':id',
                    localStorage.getItem('propertyId') +
                      '&' +
                      localStorage.getItem('suiteId')
                  ),
                  state: {
                    suite: { id: localStorage.getItem('suiteId') },
                    property: { id: localStorage.getItem('propertyId') },
                    activeTab: 0,
                    from: 'Dashboard',
                  },
                }}
              />
            ) : navFrom !== '' ? (
              <Breadcrumb
                label="Service Request"
                to={PATHS.SERVICE_REQUESTS_VIEW.replace(':id', navFrom)}
              />
            ) : (
              <Breadcrumb label="Contacts" to={PATHS.CONTACTS_LIST} />
            )}
          </div>
        </div>
        <div className="contact-details__bottom">
          <div className="contact-details__actions">
            <Button
              color="semantic"
              onClick={() => {
                this.setState({ showOverlay: true });
                onSetContactFormData(contact);
              }}
              label={<Icon glyph="pencil" weight="light" />}
            />
            <Button
              color="semantic"
              onClick={() =>
                window.confirm(
                  `Are you sure you want to delete ${contact.firstname} ${contact.lastname}?`
                ) && onDeleteContact(contact)
              }
              label={<Icon glyph="trash" weight="light" />}
            />
          </div>
          <Details
            items={[
              <div
                onClick={() =>
                  this.setState({
                    isOpen: contact && contact.profileImage ? true : false,
                  })
                }
              >
                <div className="contact-details__tenant">
                  <div className="contact-details__avatar">
                    <Avatar size="large" url={contact.profileImage} />

                    {isOpen && isOpen === true ? (
                      <ReusableLightbox
                        isOpen={isOpen}
                        onClose={() => this.setState({ isOpen: false })}
                        image={contact.profileImage}
                      />
                    ) : null}
                  </div>
                  <div className="contact-details__name">
                    {contact.firstname} {contact.lastname}
                  </div>
                  <div className="contact-details__type">{contact.type}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div className="contact-details__type">
                    {contact.status
                      ? contact.status
                      : contact.lastLoggedOn !== null
                        ? 'Active'
                        : '-'}
                  </div>
                </div>
                {contact.companyName ? (
                  <div
                    className="contact-details__type"
                    style={{
                      textAlign: 'center',
                      paddingTop: '8px',
                      color: '#3A3762',
                    }}
                  >
                    Company:{' '}
                    <span className="contact-details__type">
                      {' '}
                      {contact.companyName}
                    </span>
                  </div>
                ) : null}
                {contact.lastLoggedOn ? (
                  <div
                    className="contact-details__type"
                    style={{
                      textAlign: 'center',
                      paddingTop: '8px',
                      color: '#3A3762',
                    }}
                  >
                    Last login:{' '}
                    <span className="contact-details__type">
                      {' '}
                      {serviceRequestTableLocalTime(
                        contact.lastLoggedOn,
                        'contacts'
                      )}
                    </span>
                  </div>
                ) : null}
              </div>,
              <ContactCard contact={contact} />,
              <AddressInformation contact={contact} />,
              <Metrics
                items={[
                  {
                    key: 'Active',
                    value: counts.serviceActivesCount
                      ? counts.serviceActivesCount
                      : 0,
                  },
                  {
                    key: 'Archived',
                    value: counts.serviceArchivedCount
                      ? counts.serviceArchivedCount
                      : 0,
                  },
                ]}
              />,
              user.roles[0].role.name === 'Property Developer' ||
              user.roles[0].role.name === 'Strata Manager' ||
              user.roles[0].role.name === 'Service Provider' ||
              user.roles[0].role.name === 'Service Manager' ? (
                <div class="card">
                  <div class="card__title">Average Estimated Time</div>
                  <div class="card__body">
                    <div>{counts.avgEstimatedTime}</div>
                  </div>
                </div>
              ) : null,
              user.roles[0].role.name === 'Property Developer' ||
              user.roles[0].role.name === 'Strata Manager' ||
              user.roles[0].role.name === 'Service Provider' ||
              user.roles[0].role.name === 'Service Manager' ? (
                <div class="card">
                  <div class="card__title">Average Actual Time</div>
                  <div class="card__body">
                    <div>{counts.avgActualTime}</div>
                  </div>
                </div>
              ) : null,
              contact && contact.isSpark === true && (
                <div
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => this.onFetchMoreDetails()}
                >
                  More Details
                </div>
              ),
            ]}
          />
        </div>
        <Overlay
          showOverlay={showOverlay}
          content={
            <ContactForm
              onClose={() =>
                this.setState({ showOverlay: false }, () =>
                  onClearContactFormData()
                )
              }
              onSubmit={(data) => {
                // this.setState({ showOverlay: false })
                onSubmitContactForm(data);
              }}
              sendResetPasswordLinkToUser={sendResetPasswordLinkToUser}
              sendActivationLinkToUser={sendActivationLinkToUser}
            />
          }
        />
        {moreDetails && moreDetails.isEnableLoader ? (
          <Loader center={true} />
        ) : null}
        {moreDetails && moreDetails.isMoreDetails ? (
          <ContactMoreDetails
            closePopup={() => this.props.onClearMoreDetails()}
            details={moreDetails.moreData}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  moreDetails: state.moreDetails,
  loader: selectLoader(state),
  user: selectAuthenticatedUser(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetContactFormData: setContactFormData,
      onClearContactFormData: clearContactFormData,
      onDeleteContactById: deleteContactById,
      onFetchContactMoreDetails: onFetchContactMoreDetails,
      onClearMoreDetails: onClearMoreDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails);
